// extracted by mini-css-extract-plugin
export default {"mCard":"vC-z","image":"wC-z","imageNoBackground":"xC-z","imageHasCategory":"yC-z","fullWidth":"zC-z"};